export default __webpack_public_path__ + "static/media/pdv-compra.c33818c1.svg";